import { apiService } from "./apiService";
import { endpoints } from "@/config/endpoints";
import { pickBy } from "lodash";

export default {
  getFacilitiesData({
    page,
    perPage,
    query,
    city,
    is_owner,
    is_verified,
    external_changes_status = [],
    external_changes_source = [],
    cities = [],
    facilities_ids = [],
    groups = [],
    location_state,
    open_status,
    bing_status,
    without_gmb_address = false
  }) {
    const params = {
      page: page,
      page_size: perPage,
      q: query,
      city: city,
      is_owner: is_owner,
      is_verified,
      external_changes_status: external_changes_status.join(","),
      external_changes_source: external_changes_source.join(","),
      cities: cities.join(","),
      facilities_ids: facilities_ids.join(","),
      groups: groups.join(","),
      location_state,
      open_status,
      bing_status,
      without_gmb_address
    };

    return apiService.get(endpoints.facilities, {
      params: pickBy(params)
    });
  },

  getFacilitiesCities() {
    return apiService.get(endpoints.facilitiesCities);
  },

  getFacilitiesIds({
    query,
    city,
    is_owner,
    is_verified,
    external_changes_status = [],
    external_changes_source = [],
    cities = [],
    facilities_ids = [],
    groups = [],
    location_state,
    open_status,
    bing_status,
    has_physical_location = false
  }) {
    const params = {
      only_ids: true,
      q: query,
      city: city,
      is_owner: is_owner,
      is_verified,
      external_changes_status: external_changes_status.join(","),
      external_changes_source: external_changes_source.join(","),
      cities: cities.join(","),
      facilities_ids: facilities_ids.join(","),
      groups: groups.join(","),
      location_state,
      open_status,
      bing_status,
      has_physical_location
    };

    return apiService.get(endpoints.facilities, {
      params: pickBy(params)
    });
  },

  getFacilityData(facilityId) {
    return apiService.get(`${endpoints.facilities}${facilityId}/`);
  },

  fetchFacilitiesLabels() {
    return apiService.get(endpoints.facilitiesLabels);
  },

  fetchFacilitiesLabelsByIds(facilitiesIds) {
    return apiService.post(endpoints.facilitiesLabels, {
      facilities_ids: facilitiesIds
    });
  },

  fetchFacilitiesMoreHours({ facilitiesIds = [], onlySet = false }) {
    const params = {
      facilities_ids: facilitiesIds.join(","),
      only_set: onlySet
    };
    return apiService.post(endpoints.gmbMoreHours, pickBy(params));
  },

  getFacilityUpdateStatus(facilityId) {
    return apiService.get(
      `${endpoints.facilitiesUpdateStatuses}${facilityId}/`
    );
  },

  deleteFacility(facilityId) {
    return apiService.delete(`${endpoints.facilities}${facilityId}/`);
  },

  patchFacility(facilityId, payload) {
    return apiService.patch(`${endpoints.facilities}${facilityId}/`, payload);
  },

  importFacilityEditFile(form) {
    return apiService.post(endpoints.facilitiesImport, form);
  },

  putFacilitiesImport(payload) {
    return apiService.put(endpoints.facilitiesImport, payload);
  },

  patchFacilitiesBulkEdit(data) {
    return apiService.patch(endpoints.facilitiesBulkEdit, data);
  },

  exportFacilities({ type, ids }) {
    const payload = {
      facilities_ids: ids
    };
    const params = {
      file_type: type
    };

    return apiService.post(endpoints.facilitiesExport, payload, {
      params
    });
  },

  createFacility(payload) {
    return apiService.post(endpoints.gmbLocationCreate, payload);
  },

  createFacilityCheck(params) {
    return apiService.get(endpoints.gmbSearch, { params });
  },

  getCountries() {
    return apiService.get(endpoints.countries);
  },

  getFacilitiesForLimitsManagement() {
    return apiService.get(endpoints.facilitiesLimitsManagement);
  }
};
